export default __webpack_public_path__ + "static/media/CNo.33-8.ffa6a889.jpg";